import { render } from "./ArticleCard.vue?vue&type=template&id=7238a160&scoped=true&ts=true"
import script from "./ArticleCard.vue?vue&type=script&lang=ts"
export * from "./ArticleCard.vue?vue&type=script&lang=ts"

import "./ArticleCard.vue?vue&type=style&index=0&id=7238a160&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7238a160"]])

export default __exports__